module.exports = __webpack_public_path__ + "assets/img/img_2017.d0863c54.jpg";